module.exports = __webpack_public_path__ + "img/quality1.4b4c37b0.png";